export default __webpack_public_path__ + "static/media/gallery_08.f34b7b0f.jpg";